import React, {Component} from 'react';
import PropTypes from 'prop-types';

import DividerPanel from '../DividerPanel/DividerPanel';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import './FooterSeoLinks.less';

class FooterSeoLinks extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                links: PropTypes.arrayOf(PropTypes.shape({
                    text: PropTypes.string.isRequired,
                    url: PropTypes.string.isRequired
                })).isRequired
            })
        ).isRequired,
        panelTitle: PropTypes.string
    };

    static defaultProps = {
        isMobile: false,
        categories: [],
        panelTitle: 'More Popular Vacation Destinations'
    };

    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.categories.length) {
            return null;
        }

        return (
            <div className="FooterSeoLinks">
                <div className="FooterSeoLinks__container container">
                    <DividerPanel panelTitle={this.props.panelTitle} {...this.props} />
                </div>
            </div>
        );
    }
}

export default determineIfMobile(FooterSeoLinks);
